module.exports = __webpack_public_path__ + "img/新版-我们-介绍_02.a3c29899.jpg";